import { create } from "src/store/store";
import { UserDetails } from "./user.types";

export interface UserState {
  profile: Record<string, never> | UserDetails,
  setProfile: (userDetails: Record<string, never> | UserDetails) => void,
}

const initialState = {
  profile: {},
}

const useUserStore = create<UserState>()((set) => ({
  ...initialState,
  setProfile: (userDetails: Record<string, never> | UserDetails): void => set(() => ({ profile: { ...userDetails, }}))
}))

export default useUserStore;